var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Box } from '@mui/material';
import { useUser } from 'context/AuthContext';
import { useHistory, Link } from 'react-router-dom';
import React from 'react';
import userDataSource from 'dataSources/userDataSource';
import { Add } from '@mui/icons-material';
import LogoSygnet from 'assets/logo-sygnet.icon.svg';
import Routes from 'routes/Routes';
function stringToColor(string) {
    var hash = 0;
    var i;
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    var color = '#';
    for (i = 0; i < 3; i += 1) {
        var value = (hash >> (i * 8)) & 0xff;
        color += ("00" + value.toString(16)).slice(-2);
    }
    return color;
}
export var Workspaces = function () {
    var _a;
    var _b = useUser(), user = _b.user, userTenant = _b.userTenant, changeTenant = _b.changeTenant;
    var merchants = (_a = user === null || user === void 0 ? void 0 : user.tenants) !== null && _a !== void 0 ? _a : [];
    var history = useHistory();
    var onChangeTenant = function (id) {
        changeTenant(id);
        history.push('/dashboard');
    };
    var onBusinessCreate = function () {
        userDataSource.setTenantId(null);
        history.push('/onboard');
    };
    return (_jsxs(Stack, __assign({ width: "72px", bgcolor: "bg.light", sx: {
            overflowX: 'hidden',
            overflowY: 'auto',
            position: 'fixed',
            left: 0,
            top: 0,
            height: '100%',
            alignItems: 'center',
            zIndex: 1100,
            py: '20px',
        }, gap: 3 }, { children: [_jsx(Box, __assign({ component: Link, to: Routes.DASHBOARD, height: 32, position: "relative" }, { children: _jsx(Box, { component: "img", src: LogoSygnet, height: "100%", width: "auto" }, void 0) }), void 0), _jsxs(Stack, __assign({ gap: 2.5 }, { children: [merchants.map(function (merchant) { return (_jsx(Stack, __assign({ role: "button", bgcolor: stringToColor(merchant.tenant.name), borderRadius: 3, width: "40px", height: "40px", color: "white", justifyContent: "center", alignItems: "center", fontSize: "20px", fontWeight: "600", border: "2px solid", borderColor: "bg.light" }, ((userTenant === null || userTenant === void 0 ? void 0 : userTenant.tenant.id) === merchant.tenant.id
                        ? {
                            sx: {
                                cursor: 'pointer',
                                outline: "2px solid",
                                outlineColor: function (theme) { return theme.palette.border.main; },
                            },
                        }
                        : {
                            sx: {
                                cursor: 'pointer',
                                ':hover': {
                                    outline: "2px solid",
                                    outlineColor: function (theme) { return theme.palette.border.main; },
                                },
                            },
                        }), { onClick: function () { return onChangeTenant(merchant.tenant.id); } }, { children: merchant.tenant.name[0] }), void 0)); }), _jsx(Stack, __assign({ role: "button", bgcolor: "bg.main", borderRadius: 3, width: "40px", height: "40px", justifyContent: "center", alignItems: "center", fontSize: "20px", fontWeight: "600", border: "2px solid", borderColor: "border.main", color: "text.secondary", sx: {
                            cursor: 'pointer',
                            ':hover': {
                                backgroundColor: 'border.main',
                            },
                        }, onClick: onBusinessCreate }, { children: _jsx(Add, {}, void 0) }), void 0)] }), void 0)] }), void 0));
};
